/**
 * 路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import { customerService, refresh, contactService } from '@common/client/src/requestCustomizeMenu'
import { pullRefresh } from '@common/client/src/enablePullRefresh'
import { canApplyCustomizeTitle } from '@common/client/src/requestCustomizeTitle'
import useragent from '@finance/useragent'
import { compare, splice } from '@common/client/src/version'
import requestSuiguanjia from '@common/client/src/requestSuiguanjiaBarStyle'

import closeView from '@common/client/src/closeView'

import store from '$stores/index'

// import各业务路由模块
import routesCommon from '$routes/modules/common'
import routesAct from '$routes/modules/act'
import requestBarStyle, { canApplyBarStyle, SuiGuanJiaTransparentStyle, disabledKnPullRefresh } from '$utils/bar-style'

Vue.use(VueRouter)
const router = new VueRouter({
  routes: routesCommon.concat(
    routesAct,
  ),
})

const setTitle = (title: string) => {
  if (title && title.length > 0) {
    document.title = title
    if (useragent.isIOS) {
      const iframe = document.createElement('iframe')
      if (!useragent.isSuishouji) {
        iframe.setAttribute('src', '//res.sui.com/favicon.ico')
      }
      iframe.style.display = 'none'
      iframe.addEventListener('load', () => {
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 0)
      })
      document.body.appendChild(iframe)
    }
  }
}


// 声明一个全局变量，控制loading延时加载
let loadingTimeoutCtrl: number

/**
 * 路由进入前，统一事件处理
 * 1、开启loading
 * 2、登录控制
 */
router.beforeEach((to, from, next) => {
  clearTimeout(loadingTimeoutCtrl)
  loadingTimeoutCtrl = setTimeout(() => {
    store.commit('showLoading')
  }, 350)
  if (to.meta.needLogin) {
    store.dispatch('normalLogin').then(next).catch(() => {
      closeView()
    })
  } else {
    next()
  }
})

/**
 * 路由进入后，统一事件处理
 * 1、关闭loading
 * 2、页面title
 * 3、随手记【返回】按钮控制
 * 4、container class处理
 */
router.afterEach((to) => {
  // 是否隐藏导航头，隐藏导航头不能再调用设置导航头相关协议，会影响客户端实现
  const { isHideBar } = to.meta

  clearTimeout(loadingTimeoutCtrl)
  store.commit('hideLoading')
  // 全局控制随手记返回按钮动作
  if (to.meta.title) {
    // 更新页面title
    setTitle(to.meta.title)
  }

  // 随手记IOS12.19.0版本，需要做特殊兼容处理，不调用导航头。
  if (!(useragent.isSuishouji && useragent.isIOS && splice('12.19.0'))) {
    if (to.meta.barStyle && canApplyBarStyle) {
      if (to.meta.barStyle.isFullScreen) {
        to.meta.containerClass = (to.meta.containerClass || '') + ' bar-style'
      }
      requestBarStyle({
        barStyle: to.meta.barStyle
      })
    } else if (useragent.isSuiguanjia) {
      if (to.meta.suiguanjiaBarStyle) {
        to.meta.containerClass = (to.meta.containerClass || '') + ' bar-style'
        requestSuiguanjia(SuiGuanJiaTransparentStyle)
      } else {
        requestSuiguanjia({}, 0)
      }
    } else {
      requestBarStyle({ cancel: true })
    }

    // 是否可以使用新版标题居中导航头，右侧在线客服，下拉刷新
    if (canApplyCustomizeTitle()) {
      if (to.meta.customerService && !isHideBar) {
        const cb = () => {
          if (to.meta.customerServiceCollect) {
            const instance = new Vue()
            instance.$ssvue.collectSendRequest(to.meta.customerServiceCollect)
          }
        }
        // 11.4.8之前的IOS版本不支持联系客服，还是在线客服，安卓版本可以使用联系客服
        if (useragent.isIOS && !compare('11.4.8')) {
          customerService(cb)
        } else {
          contactService(cb)
        }
      }
      if (to.meta.pullRefresh) {
        pullRefresh(to.meta.pullRefresh)
      }
    // 兼容旧版导航头，右侧刷新
    } else if (to.meta.pullRefresh) {
      refresh()
    }
  }

  // 禁止卡牛下拉刷新
  if (to.meta.disabledKnPullRefresh) {
    disabledKnPullRefresh()
  }

  // 更换container class
  const { containerClass = '' } = to.meta
  store.commit('setContainerClass', containerClass)
})

export default router
